import React, {PureComponent} from 'react';
import AbsoluteGrid from 'crazyEditor/components/ElementsDialogs/GalleryDialog/AbsoluteGrid';
import EventListener from 'react-event-listener';
import * as Colors from 'material-ui/styles/colors';
import _ from 'lodash';
import AssetsImage, {SELECTION_TYPES} from 'MyAccount/AssetManager/ImageManager/components/AssetsImage/AssetsImage';
import {ButtonAndHeadline} from './ButtonAndHeadline';
import ReactDOM, {findDOMNode} from 'react-dom';
import Promise from 'bluebird';
const GRID_IMAGE_SIZE = 150;
const GRID_MARGIN = 40;

export const styles = {};

export default class PhotosPicker extends PureComponent {
  constructor(props) {
    super(props);
    this.gridRefPromise = new Promise(resolve => {
      this.gridRefPromiseResolve = resolve;
    });
    this.state = {
      selectedImages: {},
      gridColumnsAmount: undefined,
    };
  }

  componentDidMount() {
    window.setTimeout(this.handleResize, 250);
  }

  handleClickOutside = event => {
    const domNode = ReactDOM.findDOMNode(this);
    if (!domNode || !domNode.contains(event.target)) {
      this.setState({selectedImages: {}});
    }
  };

  handleResize = _.throttle(async () => {
    await this.gridRefPromise;
    if (this.gridRef) {
      this.setState({
        gridColumnsAmount: _.floor((this.gridRef.offsetWidth + GRID_MARGIN) / (GRID_IMAGE_SIZE + GRID_MARGIN)),
      });
    }
  }, 50);

  removeImageFromGrid = (urls, index) => {
    if (index === 0) {
      return _.slice(urls, 1);
    }
    if (index >= _.size(urls) - 1) {
      return _.slice(urls, 0, index);
    }
    const firstArrayPart = _.slice(urls, 0, index);
    const secondArrayPart = _.slice(urls, index + 1);
    return _.concat(firstArrayPart, secondArrayPart);
  };

  onChangeOrder = (from, to) => {
    const {picturesURLs} = this.props;
    if (from < _.size(picturesURLs) - 1 || to < from) {
      const removedImageArray = this.removeImageFromGrid(picturesURLs, from);
      const updatedPicturesURLs = this.addImageToGrid(removedImageArray, to, picturesURLs[from]);
      this.updatePicturesURLs(updatedPicturesURLs, true);
    }
  };

  ctrlSelect = item => {
    const {selectedImages} = this.state;
    let updatedSelectedImages;
    if (!!selectedImages[item.url]) {
      updatedSelectedImages = _.omit(selectedImages, item.url);
    } else {
      updatedSelectedImages = {...selectedImages, [item.url]: item.url};
    }
    this.lastUrlSelected = item.url;
    this.setState({selectedImages: updatedSelectedImages});
  };

  shiftSelect = (item, addToSelectedItems = false) => {
    const {picturesURLs} = this.props;
    const {selectedImages} = this.state;
    let updatedSelectedImages = addToSelectedItems ? selectedImages : {};
    const itemIndex = _.findIndex(picturesURLs, url => url === item.url);
    const lastSelectedIndex = _.findIndex(picturesURLs, url => url === this.lastUrlSelected);
    if (!this.lastUrlSelected || itemIndex === lastSelectedIndex) {
      this.regularSelect(item);
    } else {
      const {fromIndex, toIndex} =
        itemIndex < lastSelectedIndex
          ? {fromIndex: itemIndex, toIndex: lastSelectedIndex}
          : {fromIndex: lastSelectedIndex, toIndex: itemIndex};
      _.forEach(_.filter(picturesURLs, (url, index) => index >= fromIndex && index <= toIndex), url => {
        updatedSelectedImages = {...updatedSelectedImages, [url]: url};
      });
      this.setState({selectedImages: updatedSelectedImages});
    }
  };

  regularSelect = item => {
    this.lastUrlSelected = item.url;
    this.setState({selectedImages: {[item.url]: item.url}});
  };

  onSelect = (item, selectionType) => {
    switch (selectionType) {
      case SELECTION_TYPES.CTRL_SELECTION:
        this.ctrlSelect(item);
        break;
      case SELECTION_TYPES.SHIFT_SELECTION:
        this.shiftSelect(item);
        break;
      case SELECTION_TYPES.CTRL_AND_SHIFT_SELECTION:
        this.shiftSelect(item, true);
        break;
      case SELECTION_TYPES.REGULAR_SELECTION:
      default:
        this.regularSelect(item);
        break;
    }
  };

  addImageToGrid = (urls, index, url) => {
    if (index === 0) {
      return _.concat([url], urls);
    }
    if (index >= _.size(urls)) {
      return _.concat(urls, url);
    }
    const firstArrayPart = _.slice(urls, 0, index);
    const secondArrayPart = _.slice(urls, index);
    return _.concat(firstArrayPart, url, secondArrayPart);
  };

  updatePicturesURLs(value, reorder = false, deletion = false) {
    const {updatePicturesURLs} = this.props;
    updatePicturesURLs(value, reorder, deletion, !reorder && !deletion);
  }

  deleteImages = imagesUrls => {
    const {handleDelete, picturesURLs} = this.props;
    let updatedPicturesURLs = picturesURLs;
    _.forEach(imagesUrls, url => {
      updatedPicturesURLs = this.removeImageFromGrid(
        updatedPicturesURLs,
        _.findIndex(updatedPicturesURLs, imageUrl => imageUrl === url)
      );
    });
    if (handleDelete) {
      handleDelete(picturesURLs, updatedPicturesURLs);
    }
    this.setState({selectedImages: {}});
    this.updatePicturesURLs(updatedPicturesURLs, false, true);
  };

  handleFileUpload = (data, callback) => {
    const {url, imageName} = data;
    const {photosAmountLeft, maxPhotosAllowed, resourceType} = this.props;
    if (photosAmountLeft === undefined || photosAmountLeft > 0) {
      const {picturesURLs} = this.props;
      const updatedPicturesURLs = _.concat(picturesURLs || [], url);
      this.updatePicturesURLs(updatedPicturesURLs);
      callback({success: true, name: imageName, resourceType});
    } else {
      callback({
        success: false,
        name: imageName,
        resourceType,
        error: `Picture limit reached. You have exceeded the total amount (${maxPhotosAllowed}) of pictures allowed.`,
      });
    }
  };

  render() {
    const {selectedImages, gridColumnsAmount} = this.state;
    const {picturesURLs, width, maxPhotosAllowed, id, ...other} = this.props;
    const slicedPicturesURLs =
      _.size(picturesURLs) > maxPhotosAllowed ? _.slice(picturesURLs, 0, maxPhotosAllowed) : picturesURLs;
    return (
      <div style={{width}}>
        <ButtonAndHeadline
          id={id}
          selectedImages={selectedImages}
          deleteImages={this.deleteImages}
          picturesURLs={slicedPicturesURLs}
          onFileUpload={this.handleFileUpload}
          {...other}
        />
        {!_.isEmpty(slicedPicturesURLs) && (
          <div
            ref={ref => {
              if (!this.gridRef) {
                this.gridRef = ref;
                this.gridRefPromiseResolve();
              }
            }}
            style={{position: 'relative', padding: 10}}
          >
            <div
              style={{
                width: GRID_IMAGE_SIZE + 20,
                backgroundColor: Colors.grey100,
                position: 'absolute',
                top: 0,
                left: 0,
                paddingTop: GRID_IMAGE_SIZE + 15,
                paddingBottom: 5,
              }}
            >
              <span style={{marginLeft: 10}}>Main photo</span>
            </div>
            <AbsoluteGrid
              columns={gridColumnsAmount}
              elementHeight={GRID_IMAGE_SIZE}
              elementWidth={GRID_IMAGE_SIZE}
              margin={GRID_MARGIN}
              onChangeOrder={this.onChangeOrder}
            >
              {_.map(slicedPicturesURLs, (url, index) => {
                return (
                  <AssetsImage
                    id={`${id}-image-${index}`}
                    selected={!!selectedImages[url]}
                    item={{url}}
                    showCheckbox
                    key={url}
                    innerkey={index}
                    onSelect={this.onSelect}
                    imageSize={GRID_IMAGE_SIZE}
                    onDeleteButtonClick={() => this.deleteImages([url])}
                  />
                );
              })}
            </AbsoluteGrid>
          </div>
        )}
        <EventListener target="window" onResize={this.handleResize} />
        <EventListener target="document" onClick={this.handleClickOutside} />
      </div>
    );
  }
}
